<template>
  <button
    class="flex w-full items-center justify-between rounded px-1 py-0.5 text-left text-xs transition md:truncate lg:px-2"
    :class="
      parentOfActive
        ? 'bg-lexmea-gray-700 hover:bg-lexmea-gray-800'
        : 'bg-lexmea-gray-500 hover:bg-lexmea-gray-700'
    "
    :title="tocTitle"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    @click="$emit('updateList', legalTextToc)"
  >
    <span
      class="font-bold max-md:overflow-hidden max-md:text-nowrap md:truncate"
      v-text="tocTitle"
    />
    <Transition name="slide-x">
      <div v-if="hovered" class="ml-0.5">
        <i-heroicons-chevron-down-20-solid
          :class="{
            'rotate-90': !open,
          }"
          class="h-4 w-4 transform transition"
        />
      </div>
    </Transition>
  </button>
</template>

<script lang="ts" setup>
import type { IToC } from "~/models/IToC";

const props = defineProps<{
  legalTextToc: IToC;
  open: boolean;
  parentOfActive: boolean;
  columnCollapsed: boolean;
}>();

defineEmits<{
  updateList: [toc: IToC];
}>();

const { legalTextToc, columnCollapsed } = toRefs(props);
const hovered = ref<boolean>(false);

const tocTitle = useTocTitle(legalTextToc, columnCollapsed);
</script>
